import React from 'react'

import bgSvg from "../assets/doodlemap.svg"
import megapont_ape_club from "../assets/megapont_ape_club.svg"
import robots from "../assets/robots.svg"
import megacoin from "../assets/megacoin.png"
import megakongs_hero from "../assets/megakongs_hero.png"
import megapont from "../assets/megapont.png"
import mark from "../assets/mark.png"
import mrzeon from "../assets/mrzeon.png"
import slinger from "../assets/slinger.png"
import lstntfz from "../assets/lstntfz.png"

function Homepage() {
    return (
        <>

            {/* S E C T I O N - O N E */}

            <section className='section-one'>
                {/* <div className="container-fluid bg-white">
                    <div className="row m-0 justify-content-center text-center">
                        <div className="col-12">
                            <div className="Navbar mx-5 my-3 d-flex">
                                <div className='flex-grow'>
                                    <a href="#">Logo</a>
                                </div>
                                <div className='flex-1 text-center'>
                                    <a href="#">About</a>
                                    <a href="#" className='mx-5'>Marketplace</a>
                                </div>
                                <div className='button'>
                                    <button className='btn'>Connect Wallet</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className="container-fluid p-0">
                    <div className="row m-0 justify-content-center text-center">
                        <div className="col-12 p-0">
                            <div className="content-heading">
                                <h1 style={{ maxWidth: "1000px", margin: "auto" }}>MEGAPONT IS AN NFT MEMBERSHIP CLUB FOR PIONEERS</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* S E C T I O N - T W O */}

            <section className='section-two'>
                <div className="container container-width">
                    <div className="row mx-0">
                        <div className="col-md-6">
                            <div className="content">
                                <h1 className='hide-h1'>WHAT IS <br /> MEGAPONT?</h1>
                                <h1 className='show-h1'>WHAT IS MEGAPONT?</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="content" style={{ paddingRight: "10rem" }}>
                                <p>Megapont is a fictional universe in which advanced scientific mutations accelerated the evolutions of every species on Earth. Earth is currently a thriving, bustling paradise that has been at peace for a generation.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* S E C T I O N - T H R E E */}

            <section className='section-three'>
                <div className="container container-width">
                    <div className="row">
                        <div className="col-md-6 my-auto">
                            <div className="heading mb-5">
                                <h1>WHAT IS MEGAPONT <br /> APE CLUB?</h1>
                            </div>
                            <div className="content-one">
                                <div className="Gif">
                                    <div></div>
                                    <div>
                                        <img src="https://www.megapont.com/images/apes/1.gif" alt="" className='w-full' />
                                    </div>
                                    <div>
                                        <img src="https://www.megapont.com/images/apes/2.gif" alt="" className='w-full' />
                                    </div>
                                    <div>
                                        <img src="https://www.megapont.com/images/apes/3.gif" alt="" className='w-full' />
                                    </div>
                                    <div>
                                        <img src="https://www.megapont.com/images/apes/4.gif" alt="" className='w-full' />
                                    </div>
                                    <div>
                                        <img src="https://www.megapont.com/images/apes/5.gif" alt="" className='w-full' />
                                    </div>
                                    <div>
                                        <img src="https://www.megapont.com/images/apes/6.jpeg" alt="" className='w-full' />
                                    </div>
                                    <div>
                                        <img src="https://www.megapont.com/images/apes/7.gif" alt="" className='w-full' />
                                    </div>
                                    <div>
                                        <img src="https://www.megapont.com/images/apes/8.gif" alt="" className='w-full' />
                                    </div>
                                    <div>
                                        <img src="https://www.megapont.com/images/apes/9.gif" alt="" className='w-full' />
                                    </div>
                                    <div>
                                        <img src="https://www.megapont.com/images/apes/10.gif" alt=" className='w-full'" />
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="content" style={{ paddingRight: "10rem" }}>
                                <h1 className='heading-hide'>WHAT IS MEGAPONT APE CLUB?</h1>
                                <p>Megapont Ape Club is a celebration of the more scenic members of the Megapont world. Due to accelerated evolution, they have inherited many behaviours of the closely related human species. Both the good and bad.</p>
                                <img src={megapont_ape_club} alt="megapont_ape_club" className='img-fluid' />
                                <p>Chimpanzees have evolved at an accelerated rate due to a genetic mutation and as such is considered the kingmakers within Megapont. They currently reside outside of Megapont plaza and live in the idyllic paradise outside the metropolis.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* S E C T I O N - F O U R */}

            <section className='section-four'>
                <div className="container container-width">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="content">
                                <h1 className='hide-h1'>MEGAPONT <br />
                                    ROBOT <br />
                                    FACTORY
                                </h1>
                                <h1 className='show-h1'>MEGAPONT ROBOTFACTORY</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="content" style={{ paddingRight: "10rem" }}>
                                <p>The Megapont Robot Factory has been discovered, apes are busy getting the factory operational for a completely customisable and interactive mint process.</p>
                                <img src={robots} alt="robots" className='img-fluid img-four' />
                                <p style={{ marginTop: "2.5rem" }}>Megapont Apes can claim one empty robot, also known as a mainframe and a one-component crate. You can give your robot a name and trade them, along with components on the marketplace.</p>
                                <button className='btn'>Visit the Robot Factory</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* S E C T I O N - F I V E */}

            <section className='section-five'>
                <div className="container container-width">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="content-one">
                                <img src={megacoin} alt="megacoin" className='img-fluid' style={{ height: "334px", width: "230px" }} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="content" style={{ paddingRight: "10rem" }}>
                                <h1 style={{ marginBottom: "3rem" }}>MEGACOIN</h1>
                                <p>MEGACOIN is the token for the web3 community on Stacks. MEGA is the governance token for Megapont and the community initiatives that move the space towards a better, more decentralised future.</p>
                                <p>The claim period for MEGA opens in May for holders of Megapont Apes, Robots and Components. With the claim for MegaKongs opening shortly after.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* S E C T I O N - S I X */}

            <section className='section-six'>
                <div className="container container-width">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="content">
                                <h1>MEGAKONGS</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="content" style={{ paddingRight: "10rem" }}>
                                <p>MegaKongs are an expansion of the Megapont Ecosystem on the Ethereum blockchain, launching April 11th 2022</p>
                                <img src={megakongs_hero} alt="megakongs_hero" className='img-fluid' />
                                <p style={{ marginTop: "2.5rem" }}>MegaKongs will carry full membership in Megapont. The utility will be similar to Megapont Apes but proportional to our stance that “Apes are Kings”.</p>
                                <button className='btn'>Visit Megakongs</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* S E C T I O N - S E V E N */}

            <section className='section-seven'>
                <div className="container container-width">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="content">
                                <h1>THE TEAM</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="content-img">
                                <div>
                                    <a href="#">
                                        <img src={megapont} alt="megapont" className='img-fluid' />
                                        <p>@MEGAPONT</p>
                                    </a>
                                    <p>Artist</p>
                                </div>
                                <div>
                                    <a href="#">
                                        <img src={mark} alt="mark" className='img-fluid' />
                                        <p>@MRKMCKNZ</p>
                                    </a>
                                    <p>Engineering</p>
                                </div>
                                <div>
                                    <a href="#">
                                        <img src={mrzeon} alt="mrzeon" className='img-fluid' />
                                        <p>@MRZEON</p>
                                    </a>
                                    <p>Engineering</p>
                                </div>
                                <div>
                                    <a href="#">
                                        <img src={slinger} alt="slinger" className='img-fluid' />
                                        <p>@SLINGERSTAND</p>
                                    </a>
                                    <p>Community Moderator</p>
                                </div>
                                <div>
                                    <a href="#">
                                        <img src={lstntfz} alt="lstntfz" className='img-fluid' />
                                        <p>@LISTENTOFAZE</p>
                                    </a>
                                    <p>Community Moderator</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* S E C T I O N - E I G H T */}

            <section className='section-eight'>
                <div className="container container-width">
                    <div className="row justify-content-center text-center">
                        <div className="content">
                            <h1>JOIN OUR DISCORD COMMUNITY</h1>
                            <p className='mt-4'>Join our Discord to keep up to date with Megapont!</p>
                            <button className='btn'><i class="fa-brands fa-discord mx-2"></i>Join Discord</button>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Homepage
